<div class="content-heading">
    <div class="header-container">
        <h3>Producto Temporales</h3>
        <small>Añadir productos al sistema de CEQ o rechazar la alta.</small>
    </div>
</div>

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-default">
                <div class="card-body">
                    <form class="form-container" #Form="ngForm" [formGroup]="FormProductTemp"
                        (ngSubmit)="formSubmit(Form.value)">
                        <div class="row">

                            <div class="col-lg-3 col-md-12 col-sm-12">
                                <div class="form-group">
                                    <label class="form-label">
                                        C&oacute;digo de barras
                                    </label>
                                    <div class="d-block">
                                        <ngx-barcode6 [bc-format]="'CODE128'" [bc-value]="product.ProductBarcode"
                                            [bc-display-value]="true">
                                        </ngx-barcode6>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-9 col-md-12 col-sm-12">


                                <div class="form-row">

                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        Producto
                                        <input class="form-control" type="text" placeholder="Producto"
                                            name="ProductDescription" formControlName="ProductDescription" />
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        Nombre corto
                                        <input class="form-control" type="text" placeholder="Nombre corto"
                                            name="ProductName" formControlName="ProductName" />
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        Planta ID
                                        <input class="form-control" type="text" OnlyNumber="true"
                                            placeholder="Planta ID" name="ItemPlantaId"
                                            formControlName="ItemPlantaId" />
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        C&oacute;digo
                                        <input class="form-control" type="text" placeholder="Código" name="ProductCode"
                                            formControlName="ProductCode" disabled />
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        Tipo
                                        <input class="form-control" type="text" placeholder="Tipo" name="ProductType"
                                            formControlName="ProductType" />
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        Precio
                                        <input class="form-control" type="text" placeholder="Precio" name="ProductPrice"
                                            formControlName="ProductPrice" currencyFormatDir="C2" />
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        Cupo
                                        <input class="form-control" type="text" OnlyNumber="true" placeholder="Código"
                                            name="ProductConversion" formControlName="ProductConversion" />
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        Peso
                                        <input class="form-control" type="text" OnlyNumber="true" placeholder="Peso"
                                            name="ProductWeight" formControlName="ProductWeight" />
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        Contenedor
                                        <select class="form-control" formControlName="ProductContainer" name="ProductContainer">
                                            <option [ngValue]="null" disabled>Seleccione un contenedor..</option>
                                            <option *ngFor="let container of containerList" [ngValue]="container.ContainerCode">{{container.ContainerCode}} - {{container.ContainerDescription}}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        Envases
                                        <select class="form-control" formControlName="ProductUom" name="ProductUom">
                                            <option [ngValue]="null" disabled>Seleccione un contenedor..</option>
                                            <option *ngFor="let container of containerList2" [ngValue]="container.ContainerCode">{{container.ContainerCode}} - {{container.ContainerDescription}}</option>
                                        </select>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        Tiempo de Vida
                                        <input class="form-control" type="text" OnlyNumber="true" placeholder="Tiempo de Vida"
                                            name="ProductLifeDays" formControlName="ProductLifeDays" />
                                    </div>
                                </div>

                            </div>

                            <!-- botones -->
                            <div class="card-body">
                                <button type="submit" class="mr-1  btn btn-labeled btn-outline-primary mb-2"
                                    [disabled]="disabledArt">
                                    <span class="btn-label">
                                        <i class="fa fa-save" style="font-size: 1.5em;"></i>
                                    </span>
                                    <span>Guardar</span>
                                </button>&nbsp;&nbsp;
                                <button type="button" class="mr-1  btn btn-labeled btn-outline-warning mb-2" (click)="delete()"
                                    [disabled]="disabledArt">
                                    <span class="btn-label">
                                        <i class="fa fa-ban" style="font-size: 1.5em;"></i>
                                    </span>
                                    <span>Rechazar</span>
                                </button>&nbsp;&nbsp;
                                <button type="button" class="mr-1 btn btn-labeled btn-outline-danger mb-2"
                                    (click)="btnCancelOnClick()">
                                    <span class="btn-label">
                                        <i class="fa fa-chevron-circle-left" style="font-size: 1.5em;"></i>
                                    </span>
                                    <span>Salir</span>
                                </button>
                            </div>
                            <!-- fin botones -->

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>